import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_Variable } from '../../../../../_entity/variable/index.js';
import { ModuleFE_Value } from '../../../../../_entity.js';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DropDown_VariableV3 } from '../../../../../_entity/variable/ui-components.js';
import { DropDown_Value } from '../../../../../_entity/value/ui-components.js';
import { filterRelevantValues } from '../Component_RelationsTable/utils/utils.js';
import './Component_FactorVariableInfo.scss';
import { resolveValueDisplay } from '@app/hcs-shared/core';
export class Component_FactorVariableInfo extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.variable = ModuleFE_Variable.cache.unique(nextProps.selectedVariableId);
        state.value = ModuleFE_Value.cache.unique(nextProps.selectedValueId);
        state.disabled = nextProps.disabled;
        return state;
    }
    renderEntityView = (type) => {
        const view = this.state.disabled ? 'disabled' : 'selector';
        return _jsx(Component_SwitchView, { mode: view, modes: [
                {
                    key: 'disabled',
                    renderer: () => this.render_EntityCard(type),
                },
                {
                    key: 'selector',
                    renderer: () => this.render_EntityDropDown(type),
                }
            ] });
    };
    render_EntityDropDown = (type) => {
        switch (type) {
            case 'variable':
                return _jsx(DropDown_VariableV3.selectable, { selected: this.state.variable, onSelected: this.props.variableSelectionCallback });
            case 'value': {
                const compoundValue = ModuleFE_Value.cache.unique(this.state.variable?.valueId);
                const innerValues = filterRelevantValues(compoundValue);
                return _jsx(DropDown_Value.selectable, { selected: this.state.value, onSelected: this.props.valueSelectionCallback, disabled: !this.state.variable, queryFilter: value => innerValues.includes(value._id) });
            }
        }
    };
    render_EntityCard = (type) => {
        switch (type) {
            case 'variable': {
                const className = _className('factor-variable-info__card', this.props.onVariableClick && 'clickable');
                return _jsx(LL_H_C, { className: className, onClick: () => this.props.onVariableClick?.(this.state.variable), children: this.state.variable.name });
            }
            case 'value': {
                return _jsx(LL_H_C, { className: 'factor-variable-info__card', children: resolveValueDisplay(this.state.value) });
            }
        }
    };
    render() {
        return _jsxs(LL_H_C, { className: 'factor-variable-info', children: [this.renderEntityView('variable'), this.renderEntityView('value')] });
    }
}
//# sourceMappingURL=Component_FactorVariableInfo.js.map